import { EntryType, SettlementEntryOrderInput, SettlementsQueryQuery } from 'api/graphql/generated/graphql';
import { AmountFilterValue, DateFilterValue, SearchFilterOption } from 'pages/common/filters';

export interface IExportFilterObj {
  exportWithAppliedFilter: boolean;
  dateActiveRangeValue: string;
  exportDateRangeValue: string;
  exportColumnsSelectedList: Array<string>;
  exportDataLoader: boolean;
  exportDataCSV: string | null;
  exportSuccessfully: boolean;
  errorMessage: string;
}

export interface IPayoutBreakdownFilterObj {
  amountChecked: boolean;
  amount: AmountFilterValue | null;
  entryTypeChecked: boolean;
  entryType: EntryType[] | null;
  transactionIdChecked: boolean;
  transactionId: SearchFilterOption | null;
  payoutIdChecked: boolean;
  payoutId: SearchFilterOption | null;
  createdOnChecked: boolean;
  createdOn: DateFilterValue | null;
  availableOnChecked: boolean;
  availableOn: DateFilterValue | null;
}

export const getFilterCount = (filterObj: IPayoutBreakdownFilterObj) =>
  [
    filterObj.amountChecked,
    filterObj.entryTypeChecked,
    filterObj.transactionIdChecked,
    filterObj.payoutIdChecked,
    filterObj.createdOnChecked,
    filterObj.availableOnChecked,
  ].filter((value) => value).length;

export interface IPayoutBreakdownFilterObjError {
  amountError: string;
  entryTypeError: string;
  transactionIdError: string;
  payoutIdError: string;
  createdOnError: string;
  availableOnError: string;
}

export const hasFilterError = (filterObjError: IPayoutBreakdownFilterObjError) =>
  !!filterObjError.amountError ||
  !!filterObjError.entryTypeError ||
  !!filterObjError.transactionIdError ||
  !!filterObjError.payoutIdError ||
  !!filterObjError.createdOnError ||
  !!filterObjError.availableOnError;

export interface IPayoutBreakdownPageObj {
  page: number;
  last: number | null;
  before: string | null;
  first: number | null;
  after: string | null;
  orderBy: SettlementEntryOrderInput | null;
}

export type SettlementsQueryEdges = NonNullable<SettlementsQueryQuery['settlementEntries']>['edges'];
